import { OverlayTrigger } from "react-bootstrap";

export const withPopover =
  (Component) =>
  ({ popover, ...props }) => {
    return (
      <OverlayTrigger rootClose overlay={popover}>
        {({ ref, ...popoverHandlers }) => (
          <Component
            popoverRef={ref}
            popoverHandlers={popoverHandlers}
            {...props}
          />
        )}
      </OverlayTrigger>
    );
  };
